<template>
  <basic-container>
    <el-form ref="form" :model="form" label-width="110px" margin-top="0" :rules="rules">
      <el-row>
        <el-col :span="6">
          <el-form-item label="所属小区">
            <el-input v-model="form.commName" disabled="true"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="房间名称">
            <el-input v-model="form.roomName" disabled="true"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="6">
          <el-form-item label="收费单号">
            <el-input v-model="form.paybillNo" disabled="true"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="收费金额">
            <el-input v-model="form.totalPayAmount" disabled="true"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="退费单号">
            <el-input v-model="form.returnbillNo" disabled="true"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="退费总金额">
            <el-input v-model="form.totalReturnAmount" disabled="true"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="6">
          <el-form-item label="账单退费">
            <el-input v-model="form.return1Amount" disabled="true"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="预收费退费">
            <el-input v-model="form.return2Amount" disabled="true"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="停车费退费">
            <el-input v-model="form.return3Amount" disabled="true"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="临时收费退费">
            <el-input v-model="form.return4Amount" disabled="true"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="6">
          <el-form-item label="退款申请人">
            <el-input v-model="form.applyEmpName" disabled="true"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="申请时间">
            <el-input v-model="form.applyTime" disabled="true"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="退款审批人">
            <el-input v-model="form.auditEmpName" disabled="true"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="退款时间">
            <el-input v-model="form.returnTime" disabled="true"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="6">
          <el-form-item label="退款方式">
            <el-select v-model="form.returnChannel" style="width: 100%;" :disabled="true">
              <el-option
                style="padding-left: 10px;"
                v-for="item in returnChannelList"
                :key="item.dictKey"
                :label="item.dictValue"
                :value="item.dictKey"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="状态">
            <el-select v-model="form.returnStatus" style="width: 100%;" :disabled="true">
              <el-option
                style="padding-left: 10px;"
                v-for="item in returnStatusList"
                :key="item.dictKey"
                :label="item.dictValue"
                :value="item.dictKey"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="审批意见">
            <el-select v-model="form.auditStatus" style="width: 100%;" :disabled="true">
              <el-option
                style="padding-left: 10px;"
                v-for="item in auditStatusList"
                :key="item.key"
                :label="item.value"
                :value="item.key"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-col :span="12">
        <el-form-item label="退款原因">
          <el-input type="textarea" v-model="form.returnRemark" disabled="true"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="审批说明">
          <el-input type="textarea" v-model="form.auditRemark" disabled="true"></el-input>
        </el-form-item>
      </el-col>
    </el-form>
    <el-row style="margin-top: 20px; margin-bottom: 0px;">
      <el-col offset="19">
        <el-form-item>
          <el-button type="primary" @click="onSubmit" style="width: 80px;" hidden>确认</el-button>
          <el-button @click="closeDia('cancel')" style="width: 80px;">关闭</el-button>
        </el-form-item>
      </el-col>
    </el-row>
    <el-tabs v-model="activeTab">
      <el-tab-pane name="1">
        <span slot="label">账单收费退费</span>
        <avue-crud
          ref="crud"
          :data="feePayLists.billPayList"
          :option="option"
          v-model="detailForm"
          @selection-change="selectionChange"
        ></avue-crud>
      </el-tab-pane>
      <el-tab-pane name="2">
        <span slot="label">预收费退费</span>
        <avue-crud
          ref="crud"
          :data="feePayLists.prePayList"
          :option="option"
          v-model="detailForm"
          @selection-change="selectionChange"
        ></avue-crud>
      </el-tab-pane>
      <el-tab-pane name="3">
        <span slot="label">停车收费退费</span>
        <avue-crud
          ref="crud"
          :data="feePayLists.carPayList"
          :option="option"
          v-model="detailForm"
          @selection-change="selectionChange"
        ></avue-crud>
      </el-tab-pane>
      <el-tab-pane name="4">
        <span slot="label">临时收费退费</span>
        <avue-crud
          ref="crud"
          :data="feePayLists.tempPayList"
          :option="option"
          v-model="detailForm"
          @selection-change="selectionChange"
        ></avue-crud>
      </el-tab-pane>
    </el-tabs>
  </basic-container>
</template>

<script>
import { getDictionaryWithIntKey } from '../../../api/common';
import { getFeeReturnDetailList } from '@/api/v4ward/feereturn/feereturnlist';
export default {
  props: ['operateType', 'rowData'],
  name: 'payback-billdetails',
  data() {
    return {
      form: {
        commName: '',
      },
      rules: {},
      activeTab: '1',
      returnChannelList: [],
      returnStatusList: [],
      auditStatusList: [
        { key: 1, value: '同意' },
        { key: 2, value: '拒绝' },
        { key: -1, value: '未审核' },
      ],
      feePayLists: {
        billPayList: [],
        prePayList: [],
        carPayList: [],
        tempPayList: [],
      },
      option: {
        title: '',
        page: false,
        align: 'center',
        menuAlign: 'center',
        maxHeight: 200,
        menu: false,
        addBtn: false,
        refreshBtn: false,
        columnBtn: false,
        index: true,
        indexLabel: '序号',
        selection: false,
        stripe: true,
        border: true,
        tip: false,
        column: [
          {
            label: '收费类型',
            prop: 'feeSort',
            type: 'select',
            dataType: 'number',
            props: {
              label: 'dictValue',
              value: 'dictKey',
            },
            dicUrl: '/api/blade-system/dict/dictionaryWithIntKey?code=fee_sort',
          },
          {
            label: '费用名称',
            prop: 'itemsetName',
            width: 230,
          },
          {
            label: '账单周期编码',
            prop: 'billCycleNo',
          },
          {
            label: '账单开始时间',
            prop: 'billStartDate',
            type: 'date',
            format: 'yyyy-MM-dd',
          },
          {
            label: '账单结束时间',
            prop: 'billEndDate',
            type: 'date',
            format: 'yyyy-MM-dd',
          },
          {
            label: '缴费金额',
            prop: 'payAmount',
          },
          {
            label: '申退金额',
            prop: 'returnAmount',
          },
        ],
      },
    };
  },
  created() {},
  mounted() {
    this.form = this.rowData;
    this.initAllSelectionList();
    this.initDetailList();
  },
  methods: {
    initDetailList() {
      getFeeReturnDetailList(this.form.id).then((data) => {
        this.feePayLists = {
          billPayList: data.data[1],
          prePayList: data.data[2],
          carPayList: data.data[3],
          tempPayList: data.data[4],
        };
      });
    },
    initAllSelectionList() {
      getDictionaryWithIntKey('return_channel').then((data) => {
        this.returnChannelList = data.data;
      });
      getDictionaryWithIntKey('return_apply').then((data) => {
        this.returnStatusList = data.data;
      });
    },

    checkFormDataCorrect() {
      return true;
    },
    closeDia: function (closeType) {
      this.$emit('closeReturnDetailForm', closeType);
    },
    onSubmit() {},
  },
};
</script>

<style scoped>
.el-divider--horizontal {
  margin: 8px 0;
  background: 0 0;
  border-top: 1px solid #e8eaec;
}

.el-dialog__body .el-col {
  margin-bottom: 2px;
  margin-top: 2px;
}

.money-text-align .el-input--small .el-input__inner {
  text-align: center;
}
.avue-crud__pagination {
  position: relative;
  height: 0;
  margin-top: 0;
  margin-bottom: 10px;
  padding: 10px 20px;
}
</style>
